import { render, staticRenderFns } from "./Nothing2.vue?vue&type=template&id=1f7ac5fc&scoped=true"
import script from "./Nothing2.vue?vue&type=script&lang=js"
export * from "./Nothing2.vue?vue&type=script&lang=js"
import style0 from "./Nothing2.vue?vue&type=style&index=0&id=1f7ac5fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7ac5fc",
  null
  
)

export default component.exports